import { api } from "@shared/services/api-client";
import type { ApiResponse } from "@shared/types/api.types";
import type { IntroDetail, IntroInput, IntroRow } from "./types";

const base = "/admin/assessment-intros";
const one = (code: string) => `${base}/${encodeURIComponent(code)}`;

const data = async <T>(request: Promise<ApiResponse<T>>): Promise<T> => (await request).data;

export const listIntros = () => data(api.get<ApiResponse<IntroRow[]>>(base));

export const getIntro = (code: string) => data(api.get<ApiResponse<IntroDetail>>(one(code)));

/** The response is what the server stored (HTML stripped, text trimmed), not what was sent. */
export const saveIntro = (code: string, input: IntroInput) => data(api.put<ApiResponse<IntroDetail>>(one(code), input));
